var getThemedStyle = function(name) {
    return function(lightStyle, darkStyle) {
        return name === "dark" ? darkStyle : lightStyle;
    };
};
export function getThemeUtil(themeName) {
    return {
        /**
     * Helper utility for pairs of theme-specific styles. Prefer using existing
     * theme styles on theme.km, but this is useful for one-offs that are not
     * yet widely adopted in our broader theming strategy.
     *
     * Usage:
     *
     * const OneOffFoo = styled.div`
     *   border-color: ${p => p.theme.km.util.themedStyle(GREY_900, GREY_50)};
     * `;
     *
     * This will use GREY_900 when the theme is 'light', and GREY_50 when the
     * theme is 'dark'.
     */ themedStyle: getThemedStyle(themeName)
    };
}
